export const environment = {
    production: true,
    hmr: false,
    BUILD_TIMESTAMP: `'${new Date().getTime()}'`,
    DEBUG_INFO_ENABLED: true,
};
